function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.4 12.95l-2.78 1.39c-.19.1-.42.06-.58-.09l-1.87-1.87c-.2-.2-.2-.51 0-.71l1.9-1.9c.15-.15.39-.19.58-.09l2.75 1.38c.79.38.79 1.5 0 1.89zm-5.1-4.46c.31.15.37.56.13.8l-1.67 1.67-.71.71c-.2.2-.51.2-.71 0L6.2 4.53c-.4-.4.07-1.05.58-.8l9.52 4.76zM2 20.15V3.48c0-.44.53-.67.85-.36l8.77 8.51c.21.2.2.53-.01.73l-8.77 8.16a.5.5 0 01-.84-.37zm14.27-4.63l-9.39 4.7c-.51.25-.98-.4-.58-.8l7.05-7.05c.2-.2.51-.2.71 0l2.35 2.35c.23.24.16.65-.14.8z"
})));